<div [formGroup]="form" class="u-m-top--sm">
	<ng-container formArrayName="items">
		@for (control of itemsForm.controls; track control.value.fid) {
			<div [formGroupName]="$index" class="u-row u-row--sm">
				@for (field of fields(); track field.name) {
					@if (field.size) {
						<tvcore-input [class]="'u-col-md-' + field.size" [label]="(field.label || field.name) + ' *'" [name]="field.name" [showErrors]="showErrors" type="text">
							<tvcore-form-control-error name="required">Dit is verplicht.</tvcore-form-control-error>
						</tvcore-input>
					}
				}

				<div class="u-col-md-1">
					@if (itemsForm.controls.length > 1) {
						<button (click)="removeLine($index)" class="c-btn-round">
							<span class="icon-trash"></span>
						</button>
					}
				</div>
			</div>
		}
	</ng-container>

	<button (click)="addLine()" class="u-m-top--sm c-btn c-btn--sm c-btn--secundary" type="button">+ {{ itemName() }} toevoegen</button>
</div>
